module.exports = __webpack_public_path__ + "img/ruban_4.2f44dec5.png";